// Reference values vs display text.
//
// NO React or Redux imports: reviseSeed.js imports this and is loaded directly
// by a Node test.
//
// 2026-09-28, CH: revising a broker-less offer posted `broker: "—"`. The offers
// list had mapped the missing broker to the display dash, and the revision
// form seeded itself from that mapped object. The server answered with a raw
// Mongoose cast error. Display placeholders belong in render code only; any
// value that flows into form state or a request body goes through these.

const OBJECT_ID = /^[a-f0-9]{24}$/i;

/**
 * An ObjectId as a string, or '' — never a name, a dash or an object.
 * Accepts a raw id, or a populated `{ _id }` sub-document.
 */
export function asObjectId(v) {
  if (v && typeof v === 'object') return asObjectId(v._id);
  const s = typeof v === 'string' ? v.trim() : '';
  return OBJECT_ID.test(s) ? s : '';
}

/** Placeholder strings a list renders for "no value". Never real data. */
const PLACEHOLDERS = new Set(['—', '–', '-', 'n/a', 'na', 'unknown', 'unnamed', 'none', 'null', 'undefined']);

/** True when a string is only a display placeholder (or blank). */
export function isPlaceholderText(v) {
  if (v == null) return true;
  const s = String(v).trim().toLowerCase();
  return s === '' || PLACEHOLDERS.has(s);
}

/** The value, or '' when it is only a placeholder. */
export const realText = (v) => (isPlaceholderText(v) ? '' : String(v).trim());
